import { initYoutube } from './components/youtube';
import initAppearAnim from './utils/appear-anim';
import initNav from './components/navigation';
import initCategoriesNav from './components/categories-nav';
import initLogosCarousel from './blocks/logos-carousel';
import initHeaderHome from './components/header-home';
import initItemsAnim from './blocks/items-anim';
import initTabs from './blocks/tabs';
import initLogosCarouselContact from './blocks/logos-carousel-contact';
import initAnchorSingle from './components/anchor-single';
import initDropdowns from './blocks/dropdowns';
import initHeaderSpacing from './utils/header-spacing';
import initCardsOffers from './blocks/block-cards-offers';
import initgaSingle from './utils/ga-single';

// Fix de la valeur de "100vh" pour les appareils iOS + Fix de la valeur de "100vw"
function appHeight() {
    const vh = (window.innerHeight * 0.01) * 100;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    const vw = document.body.clientWidth;
    document.documentElement.style.setProperty('--vw', `${vw}px`);
}
window.addEventListener('load', appHeight);
window.addEventListener('resize', appHeight);


// Modules
initNav();

// Blocks
initLogosCarousel();
initItemsAnim();
initHeaderHome();
initTabs();
initLogosCarouselContact();
initDropdowns();
initCardsOffers();

//Utils
initAppearAnim();
initHeaderSpacing();
initgaSingle();

// Components (En dernier sinon les bouton modals dans un swiper ne s'initialise pas)
initYoutube();
initCategoriesNav();
initAnchorSingle();


